// Canonical IANA-timezone → human label formatter — el.call('zoneLabel', tz).
// TZ-LABELS-1: `analytics/pages/main.js`'s "Where the team is" TeamGrid
// rendered raw IANA identifiers straight to the DOM (`America/Denver`)
// while the Home dashboard's "Team timezones" widget already had its own
// copy of this logic in `workspace/components/IntranetRows.js`
// (`TzCluster.scope.zoneLabel`). Hoisted here (Rule 63 — extract the 3rd
// near-duplicate) so BOTH packages share ONE implementation.
//
// Output (DESIGN-ZONELABEL-DROP-UTC-WORDING-1, Nika 2026-09-14): the place
// plus a bare offset, in the SAME '±HH:MM' form analytics prints
// (analyticsOffsetLabel, WS-ANALYTICS-REMOVE-UTC-DISPLAY-TOGGLE-1). No "UTC"
// or "GMT" wording anywhere:
//   'America/Denver' → 'Denver · -06:00' (DST-correct for now)
//   'Asia/Kolkata'   → 'Kolkata · +05:30'
//   'Etc/UTC'        → '+00:00'  (a UTC-family / Etc zone is not a place)
//   'Remote'         → 'Remote'  (not a resolvable zone: pass-through)
//
// The offset for "now" still comes from Intl `timeZoneName: 'shortOffset'`
// ('GMT-6', 'GMT+5:30', 'GMT'), parsed into minutes and re-printed.
// Self-contained on purpose (FA204): frank serialises this body alone, so it
// reads no module-scope sibling.
export const zoneLabel = (timezone) => {
  if (!timezone) return 'No timezone set'
  const raw = String(timezone).trim()
  let offsetText = ''
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: raw,
      timeZoneName: 'shortOffset'
    }).formatToParts(new Date())
    offsetText = parts.find((p) => p.type === 'timeZoneName')?.value || ''
  } catch {
    return raw
  }
  const match = /^(?:GMT|UTC)(?:([+-])(\d{1,2})(?::(\d{2}))?)?$/.exec(offsetText)
  const notPlace = /^(etc\/.+|(utc|gmt|uct|universal|zulu|greenwich)([+-]?0)?)$/i.test(raw)
  const city = notPlace ? '' : raw.split('/').pop().replace(/_/g, ' ')
  if (!match) return city || raw
  const minutes = (match[1] === '-' ? -1 : 1) * (Number(match[2] || 0) * 60 + Number(match[3] || 0))
  const abs = Math.abs(minutes)
  const offset = `${minutes < 0 ? '-' : '+'}${String(Math.floor(abs / 60)).padStart(2, '0')}:${String(abs % 60).padStart(2, '0')}`
  return city ? `${city} · ${offset}` : offset
}
